import { IEmailForm } from "../interfaces/EmailForm";

const EmailFormDefaults: IEmailForm = {
  articleSubcategories: {},
  captchaSiteKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
  categoryModel: '',
  configSubCategory: {},
  enableCaptcha: false,
  email: '',
  gladlyArticlesRedirect: {},
  issueValue: '',
  isSubmitted: false,
  isSubmitError: false,
  orderNumberValue: '',
  pageName: "",
  // Old popular links
  popularLinks: {},
  // New popular topics links
  popularTopicsLinks: {},
  secondaryCategoryModel: '',
  siteId: "",
  step: 'home',
  templateType: "",
  title: 'Send Us an Email',
  topics: [],
};
Object.freeze(EmailFormDefaults);
export default EmailFormDefaults;